import { Injectable } from '@angular/core';
import { facadeFactory } from '@spartacus/core';
import { USER_BASE_FEATURE } from '../store/user-state';

@Injectable({
  providedIn: 'root',
  useFactory: () =>
    facadeFactory({
      facade: UserStatePersistenceFacade,
      feature: USER_BASE_FEATURE,
      async: true,
      methods: ['initSync'],
    }),
})
export abstract class UserStatePersistenceFacade {
  abstract initSync();
}
